import {useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useUrlUpdater} from 'components/data/WithUrlUpdater'
import {getSortParams} from 'modules/search/selectors'
import {SortUrlParams} from 'modules/search/types'
import {setSearchTrigger} from 'modules/searchBox/slice'
import {SearchTrigger} from 'modules/searchBox/types'

export const useSortBy = () => {
  const sortParams = useSelector(getSortParams)

  const {updateLocation} = useUrlUpdater()
  const dispatch = useDispatch()

  const handleChangeSort = useCallback(
    ({sortField, sortOrder}: SortUrlParams) => {
      const isChanged =
        sortParams.sortField !== sortField || sortParams.sortOrder !== sortOrder

      if (isChanged) {
        dispatch(setSearchTrigger(SearchTrigger.Sort))
      }

      updateLocation({
        sortField,
        sortOrder,
        noHostels: undefined,
        ...(isChanged ? {userSearch: '1'} : {})
      })
    },
    [sortParams, updateLocation, dispatch]
  )

  return {
    onChangeSort: handleChangeSort,
    sortParams
  }
}
